import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import { CommentingService } from '@scaffold/services/commenting.service';

/** this component filters users for the latest mentions component
 */

@Component({
  selector: 'app-comment-filter',
  templateUrl: './comment-filter.component.html',
  styleUrls: ['./comment-filter.component.scss']
})
export class CommentFilterComponent extends BaseScaffoldComponent implements OnInit {
  private _userFilter;
  set user_filter(val) {
    this._userFilter = val;
    this.commentService.filterUser(val);
  }
  get user_filter() {
    return this._userFilter;
  }

  constructor(public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private commentService:CommentingService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit(): void {
  }

}
